declare var $ : any;
declare var jQuery : any;
declare var GMR;

import VideoController from  '../../default_lp/src/VideoController';
import {IUser, ILocalUser} from '../../default_lp/src/interface/IUser';
import User from  '../../default_lp/src/User';
import CookieController from  '../../../js/lib/CookieController';
import getUriQueryParams from  '../../default_lp/src/getUriQueryParams';
import AuthForm from  '../../../blocks/auth_form/js/AuthForm';
import AuthMailForm from  '../../../blocks/auth_mail_form/js/AuthMailForm';
import DownloadForm from  '../../../blocks/download_form/js/DownloadForm';
import sendGtmEvent from "../../../blocks/helpers/sendGtmEvent";
import registrationFinishDetect from "../../../blocks/helpers/registrationFinishDetect";

import  './sass/main.scss';


class NewPopupController {
    protected $popup : JQuery;
    id = 'newPopup';
    gmr : GMR;
    state: any;
    registered : boolean;
    options : any;
    user : User;
    timer : any;
    init_time : number = 60;
    time_counter : number = 0;
    css_uri = 'https://sf.cdn.gmru.net/static/sf.mail.ru/blocks/auth_form/css/main.css';
    constructor (options : any) {
        this.registered = (options.user && options.user.user && options.user.user.local);
        this.options = options;
        this.state = {
            rendered : false,
            visible : false
        };
        this.init();
    }

    public init () {
        this.renderForm();
    }


    private renderForm () {
        var html = this.getHtmlTemplate();
        $('body').append(html);
        this.$popup = $('#' + this.id);
        this.hidePopup();
        this.state.rendered = true;
        this.initEvents();
    }

    private initEvents () {
        var that = this;
        if (!this.$popup) {
            throw new Error('Popup is not rendered');
        }
        $('.js-new-popup-close', this.$popup).on('click', function () {
            that.hidePopup();
            that.options.close_click();
            return false;
        });
        $('.js-new-popup-button', this.$popup).on('click', function () {
                that.options.button_click();
        });

    }

    private getHtmlTemplate () {
        const id = this.id;
        const button_text = this.registered ? 'Забрать подарки': 'Зарегистрироваться';
        var html = `
        <div class="popup-wrapper" id="${id}">
            <div class="new-popup">
              <div class="new-popup__close js-new-popup-close"></div>
               <div class="new-popup__logo"></div>
              <div class="new-popup__header">Ограниченное предложение!<br/>
                Зарегистрируйся прямо сейчас и получи подарки в игре!</div>
              <div class="new-popup__gifts">
              </div>
              <div class="new-popup-timer">
                <div class="new-popup-timer__header">Предложение истекает через:</div>
                <div class="new-popup-timer__timer">
                  <div class="new-popup-timer__label">секунд</div>
                  <span class="new-popup-timer__value js-new-popup-timer-value">${this.init_time}</span>
                </div>
              </div>
              <div class="news_custom_link new-popup__button js-new-popup-button">${button_text}</div>
            </div>
        </div>`;
        return html.replace(/\s\s*$/gm, "");
    }
    public showPopup () {
        if (!this.state.rendered) {
            throw new Error('You need render form before show');
        }
        if (!this.state.visible) {
            this.$popup.show();
            this.timer = setInterval(this.timerTick.bind(this), 1000);
            this.state.visible = true;
        }
    }
    private timerTick () {
        this.time_counter++;
        let diff = this.init_time - this.time_counter;
        if (diff < 0) {
            diff = 0;
            clearInterval(this.timer);
        }
        $('.js-new-popup-timer-value').html(diff);
    }

    public hidePopup () {
        this.$popup.hide();
        clearInterval(this.timer);
        this.time_counter = 0;
        this.state.visible = false;
    }

}

interface IForms {
    auth_form? : AuthForm;
    auth_mail_form? : AuthMailForm;
    download_form? : DownloadForm;
}


GMR.config({
    page:  location.href + ((location.search.indexOf('?') > -1) ? '&' : '?') + 'force_reg=1',
    signup_page : "",
    ok_enabled: true,
    ok_app_id: 1147701760,
    vk_enabled: true,
    vk_app_id: 4792019,
    fake_auth_page: "https://sf.mail.ru/dynamic/auth/",
    restore_page: "http://e.mail.ru/password/restore/",
    download_heading: 'Установка игры',
    download_url: 'https://static.dl.mail.ru/SkyforgeLoader.exe',
    download_theme: 'dark',
    "gc_id": "0.73"
});

class LandingController {
    video_controller : VideoController;
    $main_button : JQuery;
    user : User;
    forms : IForms;
    active_form : any;
    popup : NewPopupController;
    lp_url : string;
    reg_url : string;
    blur_event : any;
    focus_event : any;
    favicon_interval : any;

    constructor () {
        this.beforeInit();
        this.init();
    }
    isNewPopupBlocked () {
        return !!localStorage.getItem('new_popup_closed');
    }
    setNewPopupBlocked () {
        localStorage.setItem('new_popup_closed', '1');
        clearInterval(this.favicon_interval);
        $(window).off('blur', this.blur_event);
        $(window).off('focus', this.focus_event);

    }

    private beforeInit () {
        this.lp_url = location.href;
        this.reg_url = '/dynamic/auth/?forum_reg='+encodeURIComponent(this.lp_url + ((location.search.indexOf('?') > -1) ? '&' : '?') + 'after_reg=1');
        this.$main_button = $('.js-main-button');
        this.forms = {};
        this.video_controller = new VideoController();
        this.user = new User();
    }


    private init () {
        this.user.getUserInfo(this.getUserInfoCb.bind(this));
        if (!this.isNewPopupBlocked()) {
            this.initFaviconEvent();

        }
    }
    private initFaviconEvent () {
        var favicoInterval, favicoNum = 0;
        var that = this;
        this.favicon_interval = 0;
        var favicoChange = function(){
            if (favicoNum == 0) {
                favicoNum=1;
                $('link[rel$=icon]').remove();
                $('title').remove();
                $('head').append( $('<link rel="shortcut icon" type="image/x-icon"/>' ).attr( 'href', "https://rev.cdn.gmru.net/promo/rev/promo/4/1/images/message.ico" ) );
                $('head').append('<title>Вам сообщение</title>');
            } else {
                favicoNum=0;
                $('link[rel$=icon]').remove();
                $('title').remove();
                $('head').append( $('<link rel="shortcut icon" type="image/x-icon"/>' ).attr( 'href', "https://sf.mail.ru/sites/sf.mail.ru/files/main_favicon_0.ico" ) );
                $('head').append('<title>**********</title>');

            }
        };
        this.blur_event = function() {
            if (!$('body').hasClass('focus')){
                that.favicon_interval = setInterval(favicoChange, 1000);
                $('body').addClass('blur');
            }
        };

            $(window).blur(this.blur_event);
         this.focus_event =    function() {
             if ($('body').hasClass('blur')){
                 clearInterval(that.favicon_interval);
                 $('link[rel$=icon]').remove();
                 $('title').remove();
                 $('head').append( $('<link rel="shortcut icon" type="image/x-icon"/>' ).attr( 'href', "https://sf.mail.ru/sites/sf.mail.ru/files/main_favicon_1.ico" ) );
                 $('head').append('<title>Skyforge</title>');
                 that.popup.showPopup();
                 that.active_form.hideForm();
                 $('body').removeClass('blur').addClass('focus');
             }
         };
            $(window).focus(this.focus_event);
    }

    private getUserInfoCb (user : IUser) {
        var query_params : any = getUriQueryParams(location.search);
        let gtm_params;
        if (user.local) {
            gtm_params = {type: "user", userID: user.local.csaid};
            registrationFinishDetect(user.local);

        } else {
            gtm_params = {type: "guest"}
        }
        sendGtmEvent("ch.visit.v2", gtm_params);


        if (!user.local && ! user.global) {
            this.setUnAuthState();

        }
        if (user.global) {
            this.setMailAuthState(user);
            if (query_params.force_reg) {
                this.forms.auth_mail_form.forceReg();
            }
        }
        if (user.local) {
            if (query_params.after_reg){

            }
            this.setAuthedRegisterState();
        }
        this.popup = new NewPopupController({
            user : this.user,
            button_click : this.newPopupClick.bind(this),
            close_click : this.newPopupClose.bind(this)
        });
    }

    private setUnAuthState () {
        this.initAuthForm();
        this.forms.auth_form.showForm();
        this.$main_button.on('click', this.forms.auth_form.showForm.bind(this.forms.auth_form));
    }
    private setMailAuthState (user : IUser) {
        var nickname = this.user.getNickname();
        this.initAuthMailForm(this.reg_url);
        this.forms.auth_mail_form.setMail(nickname);
        this.forms.auth_mail_form.showForm();
        this.$main_button.on('click', this.forms.auth_mail_form.showForm.bind(this.forms.auth_mail_form));
    }
    private setAuthedRegisterState () {
        this.initDownloadForm();
        this.forms.download_form.showForm();
        this.$main_button.on('click', this.forms.download_form.showForm.bind(this.forms.download_form));
    }

    initAuthForm () {
        var options;
        if (this.forms.auth_form) {
            return false;
        }
        options = {
            gmr : GMR,
            visible : false
        };
        this.forms.auth_form = new AuthForm();
        this.forms.auth_form.init(options);
        this.active_form = this.forms.auth_form

    }
    initAuthMailForm (confirm_reg_url : string) {
        var options;
        if (this.forms.auth_mail_form) {
            return false;
        }
        if (!confirm_reg_url) {

        }
        options = {
            gmr : GMR,
            visible : false,
            confirm_reg_url : confirm_reg_url,
            gift_41: true
        };
        this.forms.auth_mail_form = new AuthMailForm();
        this.forms.auth_mail_form.init(options);
        this.active_form = this.forms.auth_mail_form

    }
    initDownloadForm () {
        var options;
        if (this.forms.download_form) {
            return false;
        }
        options = {
            gmr : GMR,
            visible : false
        };
        this.forms.download_form = new DownloadForm();
        this.forms.download_form.init(options);
        this.active_form = this.forms.download_form;
    }
    newPopupClick () {
        if (this.user && this.user.user && this.user.user.local) {
            GMR.detectAndDownload();
        } else {
            this.active_form.showForm();
        }
        this.setNewPopupBlocked();
        this.popup.hidePopup();
        this.setNewPopupBlocked();
    }
    newPopupClose () {
        this.setNewPopupBlocked();
    }
}

$(document).ready(function () {
    var lc = new LandingController();
});